import { FantasyPlayer } from "./FantasyPlayer";

export class FantasyStartTeam {
    constructor(
        public id: string,
        public name: string,
        public imageURL: string,
        public season: number,
        public division: string,
        public players: FantasyPlayer[],
    ) { }
}
